import React from "react";
import { Grid, Typography } from "@mui/material";

import { style } from "./style";

import GetImages from "@/components/GetImages";

import { useAppDispatch, useAppSelector } from "@/store/hooks";
import {
  fetchHospitalTeam,
  ipDashboardDetails,
  setSelectedHospitalId,
  setViewHospitalTeamDetail,
} from "@/store/slices/doctor/ipDashboard";

interface IProps {
  name: string;
  hospital_id: string;
}

const HospitalCard: React.FC<IProps> = (props) => {
  const { name, hospital_id: hospitalId } = props;

  const { selectedHospitalId } = useAppSelector(ipDashboardDetails);

  const dispatch = useAppDispatch();

  const hospitalSelectHandler = () => {
    dispatch(setSelectedHospitalId(hospitalId));
    dispatch(fetchHospitalTeam({ hospitalId }));
    dispatch(setViewHospitalTeamDetail({}));
  };
  return (
    <Grid
      item
      sx={{
        ...style.container,
        ...(hospitalId === selectedHospitalId ? style.active : {}),
      }}
      onClick={hospitalSelectHandler}
    >
      <Typography component={"h4"} sx={style.name}>
        <GetImages name="ClinicIcon" width="24" height="20" />
        {name}
      </Typography>
    </Grid>
  );
};
export default HospitalCard;
